import React, { Component } from 'react';
import MenuGeneral from './MenuGeneral.js';
import { Responsive, Dropdown, Icon } from 'semantic-ui-react'
import { menuService } from '../../_services/menu.service';
import { Link } from 'react-router-dom'

class Header extends Component{
  constructor(props) {
    super(props);
    
    this.state = {
      optMenu: [],
      loading: true
    };
    
    menuService.getAllByUsuarioWithPadre()
    .then(
      datos => {
        this.setState({ optMenu: datos, loading: false  });
      },
      error => {
        alert(error);
        this.setState({ loading: false  });
      }
    );  
    
    

  }
  

  render(){
    const {optMenu, loading} = this.state;
    const user = JSON.parse(localStorage.getItem('user'));
    const trigger = (
      <span>
        <Icon name='user' /> Hola {user.cUsuNombre}
      </span>
    )
    
    const options = [
      {
        key: 'inicio',
        text: (
          <Link to="/"><Icon name='home' />Inicio</Link>
        )
      },
      {
        key: 'profile',
        text: (
            <Link to="/profile"><Icon name='user' />Mi cuenta</Link>
        )
      },
      {
        key: 'documentos',
        text: (
            <Link to="/documentos"><Icon name='file' />Documentos</Link>
        )
      },
      {
        key: 'user',
        text: (
            <Link to="/login"><Icon name='power off' />Cerrar sesión</Link>
        )
      },
    ];

    return(
        <header>
            <div className="page-top-left">
              {/* <a className="logo" href='/'></a> */}
              <Link to="/" className="logo"></Link>
              <Responsive minWidth={600}>
                <h1>Informe académico</h1>
              </Responsive>
              <Dropdown className="menuprofile" trigger={trigger} options={options} />
            </div>
            <MenuGeneral
              optMenu={optMenu}
              loading={loading}
            />
        </header>
      
    )
  }
}
export default Header

